import { RouteParamsType } from '../../types/utils/router-params.type';
import { FETCH_STATUS } from '../../types/enums/fetch-status.enum';
import { LocationTabReducerKey } from './location-tab.types';

export type LocationTabLocationQueryKey = 'location_id' | 'locationId';

export const locationTabFilterProps = (
  tabPath: string,
  routeParams: RouteParamsType,
  reducer: LocationTabReducerKey
) => ({
  path: tabPath,
  routeParams,
  reducer,
  disableHistory: true as const,
});

export const sanitizeLocationTabRouteParams = (params: RouteParamsType, template: RouteParamsType): RouteParamsType =>
  Object.keys(template).reduce<RouteParamsType>(
    (acc, key) => {
      acc[key] = params[key] ?? template[key];
      return acc;
    },
    { ...template }
  );

export const serializeLocationTabRouteParams = (params: RouteParamsType): string => JSON.stringify(params);

export const toFilteredQueryParams = (params: Record<string, unknown>): Record<string, string> =>
  Object.entries(params).reduce<Record<string, string>>((acc, [key, value]) => {
    if (value !== '' && value !== null && value !== undefined) {
      acc[key] = String(value);
    }
    return acc;
  }, {});

export const buildLocationTabScopeParams = (
  params: RouteParamsType,
  template: RouteParamsType,
  locationId: number,
  organizationId: number,
  locationQueryKey: LocationTabLocationQueryKey
): RouteParamsType => ({
  ...sanitizeLocationTabRouteParams(params, template),
  [locationQueryKey]: locationId,
  org_id: organizationId,
  inc_sub: false,
});

export const buildLocationTabApiParams = (
  params: RouteParamsType,
  locationId: number,
  organizationId: number,
  locationQueryKey: LocationTabLocationQueryKey
): Record<string, string> =>
  toFilteredQueryParams({
    ...params,
    [locationQueryKey]: locationId,
    org_id: organizationId,
    inc_sub: false,
  });

export const getLocationTabListState = (
  totalItems: number | undefined,
  itemsLength: number | undefined,
  fetchStatus: FETCH_STATUS | null
): {
  hasItems: boolean;
  isLoading: boolean;
  isRejected: boolean;
  isFulfilled: boolean;
} => {
  const hasItems = (totalItems ?? itemsLength ?? 0) > 0;
  return {
    hasItems,
    isLoading: fetchStatus === FETCH_STATUS.PENDING || fetchStatus === FETCH_STATUS.NULL,
    isRejected: fetchStatus === FETCH_STATUS.REJECTED,
    isFulfilled: fetchStatus === FETCH_STATUS.FULFILLED,
  };
};
